// extracted by mini-css-extract-plugin
module.exports = {"switcherContainer":"Switcher_switcherContainer__1zxJ8","switcherItem":"Switcher_switcherItem__3tki1","switcherItemActive":"Switcher_switcherItemActive__1EIf7"};